/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Phone_Softphone_UrlInputs */

const en_forms_teams_settings_phone_softphone_url = /** @type {(inputs: Forms_Teams_Settings_Phone_Softphone_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softphone URL`)
};

const de_forms_teams_settings_phone_softphone_url = /** @type {(inputs: Forms_Teams_Settings_Phone_Softphone_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softphone-URL`)
};

/**
* | output |
* | --- |
* | "Softphone URL" |
*
* @param {Forms_Teams_Settings_Phone_Softphone_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_phone_softphone_url = /** @type {((inputs?: Forms_Teams_Settings_Phone_Softphone_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Phone_Softphone_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_phone_softphone_url(inputs)
	return de_forms_teams_settings_phone_softphone_url(inputs)
});